<template>
  <ValidationProvider ref="provider" tag="div" :rules="validationRules" :name="errorName" :vid="vid" v-slot="{ errors, validate, syncValue }">
      <label :class="labelClass" class="text-gray-400 text-xs uppercase" :for="id">{{ label }}</label>
      <select
          class="form-element"
          :class="{ inputClass, 'border-red-500': errors.length > 0 }"
          :name="name"
          :id="id"
          :required="required"
          :autofocus="autofocus"
          :disabled="disabled"
          v-model="newData"
          @input="onInput"
      >
        <slot></slot>
      </select>

      <span class="text-red-600 text-xs">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import SelectOption from "./SelectOption";
export default {
  components: {
    SelectOption
  },

  props: {
    value: {},
    label: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    firstOption: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: null,
    },
    error:{},
    validationRules: {
      type: [String, Object],
      default: ''
    },
    errorName:{
      type: String,
      default: name
    },
    vid: {
      type: String,
      default: name
    },
  },

  data() {
    return {
      newData: this.value,
    };
  },

  methods: {
    onInput(event) {
      this.newData = event.target.value;

      this.$emit('input', this.newData);
      this.$emit('change', this.newData);
    },
  },

  watch: {
    value() {
      this.newData = this.value;
    },

    open() {
      if (this.open) {
        this.newData = this.value;
      }
    },
  },
}
</script>